// deps
import React, { ReactElement, useCallback } from "react";
import classNames from "classnames";

// components
import { TimerWidget } from "@payment-ui/widgets/timer-widget";
import { UPICancelAlert, UPICancelButton, UPINote } from "../components";

// constants
import { UPI_TIMER_COLORS_V4, UPI_TIMER_CONTENT_V4 } from "@payment-ui/constants/Upi";
import { isJioHotstarFlow } from "@swiggy-private/checkout-core";

// test-ids
import { UPI_TIMER_TEST_IDS } from "@swiggy-private/payment-test-ids";

// styles
import styles from "../styles.scss";

interface UpiTimerProps {
    className?: string;
    countdownTimeInS: number;
    radius: number;
    strokeWidth: number;
    showCancelModal: boolean;
    setShowCancelModal: (show: boolean) => void;
    onCancelTransaction: VoidFunction;
    paymentAmount: string;
    itemCount: number;
    startAt: number;
}

export default function UpiTimer(props: UpiTimerProps): ReactElement {
    const { setShowCancelModal, onCancelTransaction } = props;
    const isJioHotstar = isJioHotstarFlow();

    const _UPI_TIMER_COLORS = UPI_TIMER_COLORS_V4;

    const onCancel = useCallback(
        (e: React.MouseEvent): void => {
            e.preventDefault();
            setShowCancelModal(true);
        },
        [setShowCancelModal],
    );

    const onSecondaryActionClick = useCallback((): void => {
        setShowCancelModal(false);
    }, [setShowCancelModal]);

    return (
        <>
            <div className={styles.container} data-testid={UPI_TIMER_TEST_IDS.CONTAINER}>
                <div className={styles.containerContent}>
                    <TimerWidget
                        duration={props.countdownTimeInS}
                        isPlaying
                        colors={_UPI_TIMER_COLORS}
                        size={props.radius}
                        strokeWidth={props.strokeWidth}
                        startAt={props?.startAt}
                    />
                    <div
                        className={classNames(styles.containerContentTitle, {
                            [styles.containerContentTitleisJhs]: isJioHotstar,
                        })}
                        data-testid={UPI_TIMER_TEST_IDS.TITLE}
                    >
                        {UPI_TIMER_CONTENT_V4.TITLE}
                    </div>
                    <UPINote />
                </div>
                <UPICancelButton onCancel={onCancel} />
            </div>
            <UPICancelAlert
                onCancelTransaction={onCancelTransaction}
                onSecondaryActionClick={onSecondaryActionClick}
                paymentAmount={props.paymentAmount}
                itemCount={String(props.itemCount)}
                showCancelModal={props.showCancelModal}
            />
        </>
    );
}
